import React, { useEffect, useMemo, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import "./Card.css";
import logoGrendene from "../../images/logoGrendene.svg";
import blankProfile from "../../images/blankProfile.png";
import phoneIcon from "../../images/fone.svg";
import whatsIcon from "../../images/whats.svg";
import emailIcon from "../../images/msg.svg";
import safeContactIcon from "../../images/Vector.svg";
import flagBR from "../../images/bandeira-do-brasil_1.svg";
import flagES from "../../images/bandeira-espanha_1.svg";
import flagUS from "../../images/bandeira_eua.svg";
import { QRCodeCanvas } from "qrcode.react";
import Select from "react-select";
import i18next from "i18next";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from "react-redux";
import { setTypeLanguage, setPreviewImage } from "../../redux/slices/userSlice";
import { getEmployeeDataById } from "../../service/employeesApi";
import { getByUserImg } from "../../service/fileUtils";
import LoadinSpinner from "../../components/LoadinSpinner";
import {
  BusinessCard,
  HeaderBusinessCard,
  ImageArea,
  ContentBusinessCard,
  InfoItemsArea,
  InfoItems,
  ImgCircle,
  LabelInfo,
  HeaderBusinessCardBottom
} from "../../components/style";

const Card = () => {
  const { personId } = useParams();
  const bgUrl = "/imagem-fundo-cartao.png";
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [lang, setLang] = useState("pt");
  const dispatch = useDispatch();
  const userRedux = useSelector((state) => state);
  const qrRef = useRef(null);
  const qrUrl = useMemo(() => {
    // Usa exatamente o link atual da página
    return typeof window !== "undefined" ? window.location.href : "";
  }, []);

  const langOptions = [
    { value: "pt", label: "Português", icon: flagBR },
    { value: "es", label: "Español", icon: flagES },
    { value: "en", label: "English", icon: flagUS },
  ];

  useEffect(() => {
    let mounted = true;
    setLoading(true);
    setError(null);
    getEmployeeDataById(personId)
      .then((data) => {
        console.log('[card] Dados do funcionário:', data)
        if (!mounted) return;
        setUser(data);
        
        // Extrai os dados do idioma (pt, en, ou es)
        const userData = data.pt || data.en || data.es || data;
        const imageFile = userData?.image;
        
        if (imageFile) {
          console.log('[card] Iniciando download da imagem:', imageFile)
          getByUserImg(imageFile).then(response => {
            console.log('[card] Response recebido:', response)
            if (mounted) {
              // response é o blob diretamente quando responseType='blob'
              const blob = response.data || response;
              console.log('[card] Blob:', blob)
              const url = URL.createObjectURL(blob);
              console.log('[card] URL criada:', url)
              dispatch(setPreviewImage(url))
            }
          }).catch(error => {
            console.error('[card] Erro ao carregar imagem do usuário:', error)
          })
        } else {
          console.log('[card] imageFile não existe')
        }
        setLoading(false);
      })
      .catch((e) => {
        if (!mounted) return;
        console.error('[card] Erro ao carregar dados do funcionário', e);
        setError(e);
        setLoading(false);
      });
    return () => {
      mounted = false;
    };
  }, [personId, dispatch]);

  const profile = useMemo(() => {
    if (!user) return {};
    // API can return a flat object or a per-language object. Prefer user[lang] when available.
    return user[lang] || user;
  }, [user, lang]);

  const buildLinkTel = (raw) => {
    if (!raw) return null;
    const digits = String(raw).replace(/\D/g, "");
    return digits ? `tel:${digits}` : null;
  };

  const buildLinkWhats = (raw) => {
    if (!raw) return null;
    const digits = String(raw).replace(/\D/g, "");
    return digits ? `https://wa.me/${digits}` : null;
  };

  const pickPreferredPhone = () => {
    if (!user) return { preferred: null, alt: null };
    const pref = user.save_contact_with;
    const phone = user.phone || null;
    const whatsapp = user.whatsapp || null;
    if (pref === "WHATSAPP") return { preferred: whatsapp, alt: phone };
    if (pref === "PHONE_NUMBER") return { preferred: phone, alt: whatsapp };
    return {
      preferred: phone || whatsapp,
      alt: phone && whatsapp && phone === (phone || null) ? whatsapp : phone,
    };
  };

  const downloadVCard = () => {
    if (!user) return;
    const { preferred, alt } = pickPreferredPhone();
    const clean = (v) => (v ? String(v).replace(/\D/g, "") : "");
    const lines = [
      "BEGIN:VCARD",
      "VERSION:3.0",
      `N:${user.name || ""};;;`,
      `FN:${user.name || ""}`,
      user.role || user.department
        ? `TITLE:${[user.role, user.department].filter(Boolean).join(" | ")}`
        : "",
      user.unity ? `ORG:${user.unity}` : "",
      preferred ? `TEL;TYPE=CELL,VOICE:${clean(preferred)}` : "",
      alt ? `TEL;TYPE=CELL:${clean(alt)}` : "",
      user.email ? `EMAIL;TYPE=INTERNET:${user.email}` : "",
      user.linkedin ? `URL:${user.linkedin}` : "",
      `NOTE:Cartão Digital Grendene`,
      "END:VCARD",
    ].filter(Boolean);

    const blob = new Blob([lines.join("\r\n")], {
      type: "text/vcard;charset=utf-8",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${user.name || "contato"}.vcf`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const handleDownloadQr = () => {
    try {
      // Igual na /home: usa o canvas do QR e força download
      const canvas = document.getElementById("canvasQr") || qrRef.current;
      if (!canvas) return;
      const pngUrl = canvas
        .toDataURL("image/png")
        .replace("image/png", "image/octet-stream");
      const downloadLink = document.createElement("a");
      downloadLink.href = pngUrl;
      downloadLink.download = "qrcode.png";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    } catch (_) {
      // no-op: if something goes wrong, silently ignore for now
    }
  };

  const onChangeLanguage = (opt) => {
    const value = opt?.value || "pt";
    setLang(value);
    dispatch(setTypeLanguage(value));
    try {
      i18next.changeLanguage(value);
    } catch (_) {}
  };

  const handleCopyLink = async () => {
    try {
      const text = qrUrl || (typeof window !== "undefined" ? window.location.href : "");
      if (!text) return;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(text);
      } else {
        const ta = document.createElement("textarea");
        ta.value = text;
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
      }
      toast.success("Link copiado!", {
        position: "top-center",
        autoClose: 1500,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        theme: "light",
      });
    } catch (_) {
      toast.error("Não foi possível copiar o link", {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: true,
        theme: "colored",
      });
    }
  };

  // Loading overlay using the same animation/style as Home
  if (loading) {
    return (
      <div
        style={{
          background: "rgb(53 66 194 / 15%)",
          width: "100vw",
          height: "100vh",
        }}
        className="d-flex justify-content-center align-items-center"
      >
        <LoadinSpinner color="black" height="75" width="75" />
      </div>
    );
  }

  return (
    <div
      className="card-bg"
      style={{ backgroundImage: `url(${bgUrl})` }}
      aria-label="Card background"
    >
      <div className="card-overlay card-container">
        <ToastContainer />
        {error && <div>Erro ao carregar</div>}
        {!error && (
          <>
            <div className="stack mt-3">
                <BusinessCard
                  style={{
                    display: "flex",
                    flexDirection: "column-reverse",
                    borderRadius: "26px 26px 0 0",
                    height: "22em",
                    position: "relative",
                    zIndex: 2,
                  }}
              >
                <HeaderBusinessCardBottom>
                  <button
                    type="button"
                    className="qr-download-btn"
                    onClick={handleDownloadQr}
                    aria-label="Baixar QR Code"
                  >
                    <svg
                      className="qr-icon"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path d="M3 3h8v8H3V3zm2 2v4h4V5H5zm6 0h2v2h-2V5zm0 4h2v2h-2V9zM3 13h2v2H3v-2zm4 0h4v4H7v-4zm-4 6h2v2H3v-2zm6 0h2v2H9v-2zm4-6h4v4h-4v-4zm6 0h2v2h-2v-2zm-6 6h2v2h-2v-2zm4 0h2v2h-2v-2zm4-4h2v2h-2v-2z" />
                    </svg>
                    <span>Baixar</span>
                  </button>
                </HeaderBusinessCardBottom>
                <ContentBusinessCard>
                  {/* Copy link button (top-left) */}
                  <div className="copy-link-card">
                    <button
                      type="button"
                      className="copy-link-btn"
                      onClick={handleCopyLink}
                      aria-label="Copiar link"
                      title="Copiar link"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        width="18"
                        height="18"
                        aria-hidden="true"
                      >
                        <path d="M10.59 13.41a1.996 1.996 0 0 0 2.82 0l3.59-3.59a2 2 0 1 0-2.83-2.83l-.88.88a1 1 0 1 1-1.41-1.41l.88-.88a4 4 0 1 1 5.66 5.66l-3.59 3.59a4 4 0 0 1-5.66 0 1 1 0 0 1 1.41-1.41Zm2.82-2.82a1.996 1.996 0 0 0-2.82 0l-3.59 3.59a2 2 0 1 0 2.83 2.83l.88-.88a1 1 0 1 1 1.41 1.41l-.88.88a4 4 0 1 1-5.66-5.66l3.59-3.59a4 4 0 0 1 5.66 0 1 1 0 1 1-1.41 1.41Z"/>
                      </svg>
                    </button>
                  </div>
                  <div className="qr-wrapper" style={{ width: "100%", marginTop: 20 }}>
                    <QRCodeCanvas
                      id="canvasQr"
                      ref={qrRef}
                      value={qrUrl}
                      size={140}
                      includeMargin
                    />
                  </div>
                  {/* Language selector inside the card */}
                  <div className="lang-select-card">
                    <Select
                      classNamePrefix="lang"
                      options={langOptions}
                      value={langOptions.find((o) => o.value === lang)}
                      onChange={onChangeLanguage}
                      isSearchable={false}
                      menuPlacement="auto"
                      components={{
                        Option: ({ innerProps, data }) => (
                          <div
                            {...innerProps}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 8,
                              padding: 6,
                            }}
                          >
                            <img src={data.icon} style={{ marginTop: "-22px" }} alt={data.label} width={18} height={12} />
                            <span>{data.label}</span>
                          </div>
                        ),
                        SingleValue: ({ data }) => (
                          <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                            <img
                              src={data.icon}
                              style={{ marginTop: "-22px" }}
                              alt={data.label}
                              width={20}
                              height={14}
                            />
                          </div>
                        ),
                        IndicatorSeparator: () => null,
                      }}
                      styles={{
                        container: (base) => ({ ...base, width: "100%" }),
                        control: (base) => ({
                          ...base,
                          minHeight: 34,
                          height: 34,
                          borderRadius: 8,
                          boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                          borderColor: "#e5e7eb",
                        }),
                        valueContainer: (base) => ({ ...base, padding: "0 8px" }),
                        dropdownIndicator: (base) => ({ ...base, padding: 6 }),
                        menu: (base) => ({
                          ...base,
                          borderRadius: 8,
                          minWidth: 72,
                          overflow: "hidden",
                        }),
                        menuList: (base) => ({
                          ...base,
                          padding: 6,
                          maxHeight: "none",
                          overflow: "hidden",
                        }),
                      }}
                    />
                  </div>
                </ContentBusinessCard>
              </BusinessCard>

                <BusinessCard style={{ position: "relative", zIndex: 1 }}>
                <HeaderBusinessCard>
                  <img
                    src={logoGrendene}
                    alt="grendene-logo"
                    style={{ position: "relative", top: 80 }}
                  />
                  <ImageArea
                    style={{
                      background: `url(${
                        userRedux.previewImage || blankProfile
                      }) center center`,
                    }}
                  />
                </HeaderBusinessCard>
                <ContentBusinessCard>
                  <span
                    style={{
                      font: "normal normal 800 14px/20px Montserrat",
                      color: "#19227D",
                    }}
                  >
                    {profile?.name || ""}
                  </span>
                  <span
                    style={{
                      width: "215px",
                      textAlign: "center",
                      font: "normal normal medium 13px/16px Montserrat",
                      color: "#A4A1BE",
                    }}
                  >
                    {[profile?.role, profile?.department]
                      .filter(Boolean)
                      .join(" | ")}
                  </span>
                </ContentBusinessCard>
                <InfoItemsArea>
                  <InfoItems md={3}>
                    <LabelInfo>Telefone</LabelInfo>
                    {profile?.phone ? (
                      <a href={buildLinkTel(profile.phone)} aria-label="Ligar">
                        <ImgCircle src={phoneIcon} alt="telefone" />
                      </a>
                    ) : (
                      <ImgCircle src={phoneIcon} alt="telefone" />
                    )}
                  </InfoItems>
                  <InfoItems md={3}>
                    <LabelInfo>Whatsapp</LabelInfo>
                    {profile?.whatsapp ? (
                      <a
                        href={buildLinkWhats(profile.whatsapp)}
                        target="_blank"
                        rel="noreferrer"
                        aria-label="WhatsApp"
                      >
                        <ImgCircle src={whatsIcon} alt="whatsapp" />
                      </a>
                    ) : (
                      <ImgCircle src={whatsIcon} alt="whatsapp" />
                    )}
                  </InfoItems>
                </InfoItemsArea>
                <InfoItemsArea>
                  <InfoItems md={3} className="email-justify-end">
                    <LabelInfo>E-mail</LabelInfo>
                    {profile?.email ? (
                      <a
                        href={`mailto:${profile.email}`}
                        aria-label="Enviar e-mail"
                      >
                        <ImgCircle src={emailIcon} alt="email" />
                      </a>
                    ) : (
                      <ImgCircle src={emailIcon} alt="email" />
                    )}
                  </InfoItems>
                  <InfoItems md={3}>
                    <LabelInfo>Contato</LabelInfo>
                    <button
                      type="button"
                      onClick={downloadVCard}
                      className="icon-button"
                      aria-label="Salvar contato"
                      style={{
                        background: "transparent",
                        border: "none",
                        padding: 0,
                      }}
                    >
                      <ImgCircle src={safeContactIcon} alt="salvar-contato" />
                    </button>
                  </InfoItems>
                </InfoItemsArea>
              </BusinessCard>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Card;
